import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface notesState {
  totalRecords: number | null;
  data: [] | null | any;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: notesState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const notesSlice = createSlice({
  name: ' notes',
  initialState,
  reducers: {
    setNote: (state: any, action: any) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewNote: (state: any, action: any) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setNote, addNewNote, reset } = notesSlice.actions;
export const getNote = (state: RootState) => state.notes.data;
export const addNote= (state: RootState) => state.notes.data;
export const getNoteTotalRecord = (state: RootState) => state.notes.totalRecords;
export default notesSlice.reducer;
